package com.merkost.handpass.api.enums

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class ListingStatus(val value: String) {
    @SerialName("draft") DRAFT("draft"),
    @SerialName("active") ACTIVE("active"),
    @SerialName("sold") SOLD("sold"),
    @SerialName("expired") EXPIRED("expired"),
    @SerialName("deleted") DELETED("deleted"),
    @SerialName("under_review") UNDER_REVIEW("under_review"),
    @SerialName("suspended") SUSPENDED("suspended");

    companion object {
        fun fromString(value: String): ListingStatus =
            entries.find { it.value == value.lowercase() } ?: DRAFT

        fun fromDbValue(value: String): ListingStatus = fromString(value)
    }
}
